import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const hasITAccess = (user) => {
  if (!user || user.active === false) return false;

  const isSuperAdmin =
    user.role === "admin" && user.admin_level === "super_admin";

  const permissions = new Set(user.permissions || []);

  const isITAgent =
    user.role === "staff" &&
    user.department === "it_support" &&
    (permissions.has("support.tickets.read") ||
      permissions.has("support.tickets.manage") ||
      permissions.has("it.vault.read") ||
      permissions.has("it.vault.manage"));

  return isSuperAdmin || isITAgent;
};

export default function ITRouteGuard({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f3f6f4]">
        <div className="text-center">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-[#d8e1dc] border-t-[#7C1F30]" />
          <p className="mt-3 text-sm text-[#66736c]">
            Verifying Service Desk access...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/it/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (!hasITAccess(user)) {
    if (user.role === "admin") {
      return <Navigate to="/admin" replace />;
    }

    if (user.role === "vendor") {
      return <Navigate to="/vendor/dashboard" replace />;
    }

    return <Navigate to="/" replace />;
  }

  return children;
}

export { hasITAccess };
